// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseDBDocument {
    static getAttributeTypeMap() {
        return EnterpriseDBDocument.attributeTypeMap;
    }
}
EnterpriseDBDocument.discriminator = undefined;
EnterpriseDBDocument.additionalProperties = false;
EnterpriseDBDocument.attributeTypeMap = [
    {
        "name": "enterpriseDBDocumentId",
        "baseName": "enterpriseDBDocumentId",
        "type": "number"
    },
    {
        "name": "sequence",
        "baseName": "sequence",
        "type": "number"
    },
    {
        "name": "fileName",
        "baseName": "fileName",
        "type": "string"
    },
];
//# sourceMappingURL=enterpriseDBDocument.js.map